export const GOOGLE_CHANNEL = 'GOOGLE';
export const FACEBOOK_CHANNEL = 'FACEBOOK';
export const TIKTOK_CHANNEL = 'TIKTOK';
export const SHEET_CHANNEL = 'SHEET';
export const ANALYTICS_CHANNEL = 'ANALYTICS';
export const LOOKER_CC_CHANNEL = 'LOOKER_CC';
export const DATA_NODE_CHANNEL = 'DATA_NODE';
export const LINKEDIN_CHANNEL = 'LINKEDIN';
export const SHOPIFY_CHANNEL = 'SHOPIFY';
export const TIENDA_NUBE_CHANNEL = 'TIENDA_NUBE';
export const KLAVIYO_CHANNEL = 'KLAVIYO';
export const WOOCOMMERCE_CHANNEL = 'WOOCOMMERCE';
export const VTEX_CHANNEL = 'VTEX';

export const CHANNEL_TYPE_ANALYTICS = "ANALYTICS";
export const CHANNEL_TYPE_PAID_MEDIA = "PAID_MEDIA";
export const CHANNEL_TYPE_ECOMMERCE = "ECOMMERCE";
export const CHANNEL_TYPE_EMAIL_MARKETING = "EMAIL_MARKETING";

export const CHANNEL_INFO_BY_CHANNEL = {
    [GOOGLE_CHANNEL]: {
        Spanish: 'Google Ads',
        CreateAccount: false,
        dailyLimitEnabled: true,
        primaryAccountType: true, // Esto define si puede usarse de base en un bucc de un presupuesto
        hasActions: true,
        hasPrimaryConversions: true, // Define si el canal tiene el concepto de conversiones primarias
        hasIncludeAllConversionsSetting: true, //  Define si las campañas/adgroups tienen "conversiones" de forma default desde la api
        channelType: CHANNEL_TYPE_PAID_MEDIA,
        optionToConnectNewAccountsSeparately: false  // Si es true quiere decir que en la solapa de conexiones de la agencia se pueden conectar nuevas cuentas de a una
    },
    [FACEBOOK_CHANNEL]: {
        Spanish: 'Facebook Ads',
        CreateAccount: false,
        dailyLimitEnabled: true,
        primaryAccountType: true,
        hasActions: true,
        hasPrimaryConversions: false,
        hasIncludeAllConversionsSetting: false,
        channelType: CHANNEL_TYPE_PAID_MEDIA,
        optionToConnectNewAccountsSeparately: false
    },
    [TIKTOK_CHANNEL]: {
        Spanish: 'Tiktok Ads',
        CreateAccount: false,
        dailyLimitEnabled: true,
        primaryAccountType: true,
        hasActions: true,
        hasPrimaryConversions: true,
        hasIncludeAllConversionsSetting: true,
        channelType: CHANNEL_TYPE_PAID_MEDIA,
        optionToConnectNewAccountsSeparately: false
    },
    [LINKEDIN_CHANNEL]: {
        Spanish: 'LinkedIn Ads',
        CreateAccount: false,
        dailyLimitEnabled: true,
        primaryAccountType: true,
        hasActions: false,
        hasPrimaryConversions: true,
        hasIncludeAllConversionsSetting: true,
        channelType: CHANNEL_TYPE_PAID_MEDIA,
        optionToConnectNewAccountsSeparately: false
    },
    [SHEET_CHANNEL]: {
        Spanish: 'CSV online (ej. Google Sheet)',
        CreateAccount: true,
        dailyLimitEnabled: true,
        primaryAccountType: true,
        hasActions: true,
        hasPrimaryConversions: true,
        hasIncludeAllConversionsSetting: true,
        channelType: CHANNEL_TYPE_PAID_MEDIA
    },
    [ANALYTICS_CHANNEL]: {
        Spanish: 'GA4',
        CreateAccount: false,
        dailyLimitEnabled: false,
        primaryAccountType: false,
        hasActions: false,
        hasPrimaryConversions: true,
        hasIncludeAllConversionsSetting: false,
        channelType: CHANNEL_TYPE_ANALYTICS,
        optionToConnectNewAccountsSeparately: false
    },
    [SHOPIFY_CHANNEL]: {
        Spanish: 'Shopify',
        CreateAccount: false,
        dailyLimitEnabled: false,
        primaryAccountType: false,
        hasActions: false,
        hasPrimaryConversions: false,
        hasIncludeAllConversionsSetting: false,
        channelType: CHANNEL_TYPE_ECOMMERCE,
        optionToConnectNewAccountsSeparately: true
    },
    [TIENDA_NUBE_CHANNEL]: {
        Spanish: 'Tiendanube',
        CreateAccount: false,
        dailyLimitEnabled: false,
        primaryAccountType: false,
        hasActions: false,
        hasPrimaryConversions: false,
        hasIncludeAllConversionsSetting: false,
        channelType: CHANNEL_TYPE_ECOMMERCE,
        optionToConnectNewAccountsSeparately: true
    },
    [KLAVIYO_CHANNEL]: {
        Spanish: 'Klaviyo',
        CreateAccount: false,
        dailyLimitEnabled: false,
        primaryAccountType: false,
        hasActions: false,
        hasPrimaryConversions: false,
        hasIncludeAllConversionsSetting: false,
        channelType: CHANNEL_TYPE_EMAIL_MARKETING,
        optionToConnectNewAccountsSeparately: true
    },
    [WOOCOMMERCE_CHANNEL]: {
        Spanish: 'WooCommerce',
        CreateAccount: false,
        dailyLimitEnabled: false,
        primaryAccountType: false,
        hasActions: false,
        hasPrimaryConversions: false,
        hasIncludeAllConversionsSetting: false,
        channelType: CHANNEL_TYPE_ECOMMERCE,
        optionToConnectNewAccountsSeparately: true
    },
    [VTEX_CHANNEL]: {
        Spanish: 'VTEX',
        CreateAccount: false,
        dailyLimitEnabled: false,
        primaryAccountType: false,
        hasActions: false,
        hasPrimaryConversions: false,
        hasIncludeAllConversionsSetting: false,
        channelType: CHANNEL_TYPE_ECOMMERCE,
        optionToConnectNewAccountsSeparately: true
    }
}


/**
 * Clase utilitaria para operaciones relacionadas con canales
 */
export class ChannelsHelper {
    /**
     * Devuelve un array con el listado de canales donde optionToConnectNewAccountsSeparately es true
     * @returns {Array} - Array con los nombres (keys) de los canales
     */
    static getChannelsWithSeparateAccountConnectionOption() {
        return Object.keys(CHANNEL_INFO_BY_CHANNEL).filter(channel =>
            CHANNEL_INFO_BY_CHANNEL[channel].optionToConnectNewAccountsSeparately === true
        );
    }

    static channelHasCampaignOrAdgroupLevel(channel) {
        return CHANNEL_INFO_BY_CHANNEL[channel]?.channelType === CHANNEL_TYPE_PAID_MEDIA;
    }
}